import { useAuth } from 'oidc-react';
import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setAuthState } from '../store/states/UserSlice';

export const Logout = (): ReactElement => {
  const { t } = useTranslation();

  const auth = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    //logout from the oidc after redirect to the logout page
    auth.signOut();
    dispatch(setAuthState('logout'));
  }, [dispatch, auth]);

  return <h4> {t('messages.logoutMessage')} </h4>;
};
